"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMedalCheckOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.medal-check_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "medal-check_outline_svg__transparent_box" },
            React.createElement("path", { className: "medal-check_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "medal-check_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "medal-check_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M27 12a11 11 0 10-18 8.48v11.14l7-3.5 7 3.5V20.48A11 11 0 0027 12zM7 12a9 9 0 119 9 9 9 0 01-9-9zm14 16.38l-5-2.5-5 2.5v-6.59a10.94 10.94 0 0010 0z" }),
            React.createElement("path", { d: "M20.63 10.83V8l-5.09 5.08-2.49-2.49-1.47 1.36 3.94 3.97 5.11-5.09z" }))));
}
exports.default = SvgMedalCheckOutline;
//# sourceMappingURL=MedalCheckOutline.js.map